module.exports = __webpack_public_path__ + "static/media/qatar-logo.1314da44.svg";